export default "__VITE_ASSET__De5ao4cN__"